import React from 'react';
import {Box, Tab, Tabs, Tooltip} from '@mui/material';
import {Outlet, useLocation, useNavigate} from 'react-router';
import SourcesFileViewerModal from '../products/reportEditorPage/leftPanel/components/SourcesFileViewerModal';
import useCollectionMaterialUploadQueue from './components/useCollectionMaterialUploadQueue';

const TABS = [
    {label: 'Tasks', path: '/collection/tasks'},
    {label: 'Materials', path: '/collection/data'},
    {label: 'IIR', path: '/collection/iir', tooltip: 'Intelligence Information Report'},
];

export default function CollectionLayout() {
    const location = useLocation();
    const navigate = useNavigate();

    const value = TABS.findIndex((t) => location.pathname.startsWith(t.path));
    const tabIndex = value < 0 ? 0 : value;
    const isEditor = /\/collection\/iir\/[^/]+/.test(location.pathname);

    // Queue processor mounted here so uploads survive navigation across tabs.
    // Per-task progress is shown inline in the Collected Materials table rows —
    // no separate queue panel needed.
    useCollectionMaterialUploadQueue();

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0}}>
            <Tabs
                value={tabIndex}
                onChange={(_, idx) => navigate(TABS[idx].path)}
                sx={{borderBottom: 1, borderColor: 'divider', px: 2, flexShrink: 0}}
            >
                {TABS.map((t) => (
                    t.tooltip ? (
                        <Tooltip key={t.path} title={t.tooltip} arrow placement="bottom">
                            <Tab label={t.label}/>
                        </Tooltip>
                    ) : (
                        <Tab key={t.path} label={t.label}/>
                    )
                ))}
            </Tabs>
            <Box sx={{flex: 1, minHeight: 0, overflow: isEditor ? 'hidden' : 'auto'}}>
                <Outlet/>
            </Box>
            <SourcesFileViewerModal/>
        </Box>
    );
}
